import { isSafeConnectionUrl } from './isSafeConnectionUrl';

/**
 * Navigate to a backend-supplied URL only when it passes isSafeConnectionUrl
 * (relative path, or absolute https: with no embedded credentials). Any unsafe
 * value — javascript:/non-https/protocol-relative/credentialed, or a non-string —
 * falls back to the application origin instead of being used as the target.
 * Centralises the CWE-601/CWE-79 guard previously inlined at each sink.
 */
export const safeNavigate = (candidate: unknown): void => {
    if (isSafeConnectionUrl(candidate)) {
        window.location.assign(candidate as string);
    } else {
        window.location.assign(window.location.origin);
    }
};

export default safeNavigate;
